module.exports = __webpack_public_path__ + "media/mypage/images/top1-94f013878c9195f1532c9925d1fcab5e.jpg";